export const environment = {
  production: false,
  appEnv: 'staging',
  apiBase: '/api',
  qrResolverBase: 'https://qr.printman.app',
};